"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _DefaultIndicator = _interopRequireDefault(require("./DefaultIndicator"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _core = require("@emotion/core");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Loading =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Loading, _React$PureComponent);
  (0, _createClass2.default)(Loading, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.progress !== state.loading) {
        return {
          loading: props.progress && props.delay === undefined
        };
      }

      return null;
    }
  }]);

  function Loading(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Loading);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Loading).call(this, props));

    _this.componentDidUpdate = function () {
      if (_this.props.delay && _this.props.progress) {
        if (!_this.state.loading) {
          clearTimeout(_this.delayTimer);
          _this.delayTimer = setTimeout(function () {
            if (!_this.unmounted) {
              _this.setState({
                loading: true,
                delayStarted: false
              });
            }
          }, _this.props.delay);
        }
      } else {
        if (_this.delayTimer) {
          _this.stopDelayTimer();
        }
      }
    };

    _this.componentWillUnmount = function () {
      _this.unmounted = true;

      _this.stopDelayTimer();
    };

    _this.stopDelayTimer = function () {
      if (_this.delayTimer) {
        clearTimeout(_this.delayTimer);
      }
    };

    _this.indicator = null;
    _this.state = {
      delayStarted: false,
      loading: props.progress && props.delay === undefined
    };
    _this.unmounted = false;
    return _this;
  }

  (0, _createClass2.default)(Loading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          maskClassName = _this$props.maskClassName,
          disableMask = _this$props.disableMask,
          uia = _this$props.uia,
          htmlFor = _this$props.htmlFor,
          size = _this$props.size,
          indicator = _this$props.indicator,
          theme = _this$props.theme,
          children = _this$props.children,
          progress = _this$props.progress,
          indicatorContent = _this$props.indicatorContent,
          restProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "maskClassName", "disableMask", "uia", "htmlFor", "size", "indicator", "theme", "children", "progress", "indicatorContent"]);
      var defaultIndicatorContent = indicatorContent;

      if (!defaultIndicatorContent && theme.components.loading.defaultIcon) {
        defaultIndicatorContent = (0, _core.jsx)(_Icon.default, {
          color: theme.components.loading.colorName,
          name: theme.components.loading.defaultIcon,
          size: size,
          uia: "loading"
        });
      }

      if (!children) {
        return (0, _core.jsx)("div", (0, _extends2.default)({
          className: className,
          "aria-busy": true,
          htmlFor: htmlFor,
          "data-uia-loading": uia
        }, restProps), indicator ? indicator : (0, _core.jsx)(_DefaultIndicator.default, {
          size: size,
          theme: theme,
          indicatorContent: defaultIndicatorContent
        }));
      }

      if (!this.state.loading) {
        return children;
      } // short circle on embeded mode, do bypass when not loading


      return (0, _core.jsx)(LoadingWrapper, (0, _extends2.default)({
        className: className,
        "aria-busy": progress,
        "data-uia-loading": uia
      }, restProps), (0, _core.jsx)(IndicatorWrapper, null, (0, _core.jsx)(_DefaultIndicator.default, {
        size: size,
        theme: theme,
        indicatorContent: defaultIndicatorContent
      }), !disableMask && (0, _core.jsx)(LoadingMask, {
        className: maskClassName
      })), children);
    }
  }]);
  return Loading;
}(_react.default.PureComponent);

var IndicatorWrapper = (0, _theme.styled)('div')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around'
});
var LoadingWrapper = (0, _theme.styled)('div')(_templateObject());
var LoadingMask = (0, _theme.styled)('div')(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return "\n      background-color: ".concat(theme.components.loading.mask.backgroundColor, ";\n      opacity: ").concat(theme.components.loading.mask.opacity, ";\n    ");
});
Loading.defaultProps = {
  size: 'medium'
};

var _default = (0, _theme.withTheme)(Loading);

exports.default = _default;